import React, { useState, useEffect, useRef } from 'react';
import IFrameWrapper from "../IFrameWrapper/IFrameWrapper";
import Button from 'react-bootstrap/Button'; // Using Bootstrap for styling the button
import {PlayCircleOutline} from "@material-ui/icons";
import {useSelector} from "react-redux";
import AutoLoadToggle from "../../AutoLoadToggle/AutoLoadToggle";


export default function ResizableIframe({ src, link, title, horizontalOnly = false , failContent = "Failed to load content.", alwaysLoad = false}) {
    const [iframeWidth, setIframeWidth] = useState(0);
    const containerRef = useRef(null);
    const userPrefs = useSelector(state => state.auth.userPreferences);
    const autoLoad = (userPrefs && userPrefs.auto_load_game_demos && userPrefs.auto_load_game_demos > 0) || alwaysLoad;
    const [isIframeVisible, setIsIframeVisible] = useState(autoLoad); // Control visibility of the iframe
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });


    useEffect(() => {
        const updateIframeSize = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth; // Get the width of the container
                setIframeWidth(containerWidth);
            }
        };
        const handleResizeScreen = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // Set the initial size
        updateIframeSize();

        // Update size when the window is resized
        window.addEventListener('resize', updateIframeSize);
        window.addEventListener('resize', handleResizeScreen);

        return () => {
            window.removeEventListener('resize', updateIframeSize);
            window.removeEventListener('resize', handleResizeScreen);
        };
    }, []);

    useEffect(() => {
        setIsIframeVisible(autoLoad)
    }, [src, link, title, autoLoad]);


    const handlePlayButtonClick = () => {
        setIsIframeVisible(true); // Show the iframe when the Play Game button is clicked
    };

    const aspectRatio = 16 / 9;
    const iframeHeight = horizontalOnly ? 167 : iframeWidth / aspectRatio;


    return (
        <div ref={containerRef} style={{width: '100%', alignSelf: "center", maxWidth: horizontalOnly ? 1000 : '95%'}}>
            {screenSize.width <= 774 ?
                <div style={{marginTop: -12, paddingBottom: 2, fontStyle: "italic", color: "darkgray"}}>WebGL build is available on pc.</div> :
                (!isIframeVisible ? (
                <>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    width: iframeWidth,
                    height: iframeHeight,
                    backgroundColor: "#e3e3e4"
                }}>
                    <Button
                        style={{
                            fontSize: iframeWidth / 32,
                            backgroundColor: "#f85c5c",
                            borderColor: "#f85c5c",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px' // Adding space between icon and text
                        }}
                        onClick={handlePlayButtonClick}
                    >
                        <PlayCircleOutline style={{ fontSize: iframeWidth / 24 }} />
                        <span style={{paddingBottom: iframeWidth / 256}}>Run game</span>
                    </Button>
                </div>
                    {!alwaysLoad && <div style={{float: "right", paddingRight: 4}}>
                        <AutoLoadToggle/>
                    </div>}
                </>
            ) : <>
                    {iframeWidth > 0 && ( // Only render iframe when width is calculated and it's visible
                        <IFrameWrapper
                            src={src}
                            width={iframeWidth}
                            height={iframeHeight}
                            failContent={failContent}
                            embedGame={true}
                        >
                            <a href={link}>Play {title} on itch.io</a>
                        </IFrameWrapper>)}
                    {!alwaysLoad && <div style={{float: "right", paddingRight: 4}}>
                        <AutoLoadToggle/>
                    </div>}
                </>
)}
        </div>
    );
}